import { bootstrapApplication } from '@angular/platform-browser';
import { Component, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, RouterOutlet, Routes } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { authGuard, analystGuard } from './app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'portal',
    pathMatch: 'full'
  },
  // ── Ruta pública ─────────────────────────────────────
  {
    path: 'login',
    loadComponent: () => import('./app/features/login/login').then(m => m.LoginComponent)
  },
  // Destino del redirect de /api/v1/auth/microsoft/callback (backend) tras
  // el login con Microsoft — pública, el JWT llega en la query string.
  {
    path: 'auth/callback',
    loadComponent: () => import('./app/features/auth-callback/auth-callback').then(m => m.AuthCallbackComponent)
  },
  // ── Rutas protegidas (requieren JWT válido) ───────────
  // Proveedor con clave temporal (2026-09-22, Fase 2) -- authGuard redirige
  // aquí automáticamente si debeCambiarPassword() es true, ver auth.guard.ts.
  {
    path: 'proveedor/cambiar-password',
    canActivate: [authGuard],
    loadComponent: () => import('./app/features/cambiar-password/cambiar-password').then(m => m.CambiarPasswordComponent)
  },
  {
    path: 'portal',
    canActivate: [authGuard],
    loadComponent: () => import('./app/features/portal-proveedor/portal-proveedor').then(m => m.PortalProveedorComponent)
  },
  {
    path: 'analitico',
    canActivate: [authGuard],
    loadComponent: () => import('./app/features/reporte-analitico/reporte-analitico').then(m => m.ReporteAnaliticoComponent)
  },
  {
    path: 'libro-visual',
    canActivate: [authGuard],
    loadComponent: () => import('./app/features/libro-visual/libro-visual').then(m => m.LibroVisualComponent)
  },
  // Vista Mundial: solo role="analyst" (interno) — analystGuard redirige a
  // /unauthorized si un usuario role="supplier" intenta entrar por URL.
  {
    path: 'mundial',
    canActivate: [analystGuard],
    loadComponent: () => import('./app/features/world-view/world-view').then(m => m.WorldViewComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./app/features/login/login').then(m => m.LoginComponent)
  },
  // ── Fallback ──────────────────────────────────────────
  {
    path: '**',
    redirectTo: 'login'
  }
];

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    template: `
    <div class="app-container">
      <router-outlet></router-outlet>
    </div>
  `
})
export class AppComponent {}

bootstrapApplication(AppComponent, {
  providers: [
    // Zoneless (Fase 4 del plan de migración): zone.js queda completamente
    // retirado de dependencies/polyfills -- la detección de cambios corre
    // por eventos de Angular (bindings, router, HttpClient, async pipe) y
    // ChangeDetectorRef.markForCheck() explícito en los puntos ya auditados
    // (Chart.js, setTimeout de animaciones) que antes dependían de zone.js.
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // Interceptor JWT: adjunta Bearer token en cada petición al backend.
    // Interceptor de errores: 401 -> logout + redirect a /login (después del
    // authInterceptor en la lista, así también cubre la propia respuesta 401).
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]))
  ]
}).catch(err => console.error(err));


